module.exports = __webpack_public_path__ + "static/media/sf-trial-2.6d44367f.mp3";